module.exports = __webpack_public_path__ + "static/media/abattoir-picture-1.841e0da6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Abattoir/abattoir-picture-1.jpg
// module id = 614
// module chunks = 0 1 2 3 4 6